import { render } from "./ViewCollection.vue?vue&type=template&id=397ca294&ts=true"
import script from "./ViewCollection.vue?vue&type=script&lang=ts"
export * from "./ViewCollection.vue?vue&type=script&lang=ts"

import "./ViewCollection.vue?vue&type=style&index=0&id=397ca294&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__